<div class="crud-item-page">
  <form [formGroup]="form">

    <ng-container *ngFor="let inputFormGroup of inputFormDisplay; let i = index; let last = last">
      <div class="crud-item-section">
        <ng-container *ngFor="let input of inputFormGroup">
          <ng-container *ngTemplateOutlet="getInputFormTemplate(input)"></ng-container>
        </ng-container>
      </div>
      <mat-divider *ngIf="!last"></mat-divider>
    </ng-container>


    <ng-template #assetTypeTemplate>
      <span>
        <mat-form-field matTooltip="Select a Asset Type from the list"
          [matTooltipDisabled]="disabledTooltip(this.assetType)">
          <mat-label i18n="@@type.Asset.assetType">Asset Type</mat-label>
          <mat-select formControlName="assetType" id="assetType" (ngModelChange)="assetTypeChanging($event)"
            [(ngModel)]="item.assetType" (ngModelChange)="assetTypeChanged($event)" #assetType placeholder="Asset Type"
            [compareWith]="assetTypeCompare">
            <mat-option>Other</mat-option>
            <mat-option *ngFor="let assetType of assetTypeSelectionList" [value]="assetType">
              {{assetType?.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </span>
    </ng-template>

    <ng-template #businessUnitTemplate>
      <span>
        <mat-form-field matTooltip="Select a Business Unit from the list"
          [matTooltipDisabled]="disabledTooltip(this.businessUnit)">
          <mat-label i18n="@@type.Asset.businessUnit">Business Unit</mat-label>
          <mat-select formControlName="businessUnit" id="businessUnit" (ngModelChange)="businessUnitChanging($event)"
            [(ngModel)]="item.businessUnit" (ngModelChange)="businessUnitChanged($event)" #businessUnit
            placeholder="Business Unit" [compareWith]="businessUnitCompare">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let businessUnit of businessUnitSelectionList" [value]="businessUnit">
              {{businessUnit?.buId}} - {{businessUnit?.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </span>
    </ng-template>

    <ng-template #costCentreTemplate>
      <span>
        <mat-form-field matTooltip="Select a Cost Centre from the list"
          [matTooltipDisabled]="disabledTooltip(this.costCentre)">
          <mat-label i18n="@@type.Asset.costCentre">Cost Centre</mat-label>
          <mat-select formControlName="costCentre" id="costCentre" (ngModelChange)="costCentreChanging($event)"
            [(ngModel)]="item.costCentre" (ngModelChange)="costCentreChanged($event)" #costCentre
            placeholder="Cost Centre" [compareWith]="costCentreCompare">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let costCentre of costCentreSelectionList" [value]="costCentre">
              {{costCentre?.ccId}} - {{costCentre?.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </span>
    </ng-template>

    <ng-template #locationTemplate>
      <span>
        <mat-form-field matTooltip="Location" [matTooltipDisabled]="disabledTooltip(this.location)" class="crud-item-input-wide">
          <mat-label i18n="@@type.Asset.location">Location</mat-label>
          <input matInput formControlName="location" id="location" (ngModelChange)="locationChanging($event)"
            [(ngModel)]="item.location" (ngModelChange)="locationChanged($event)" #location maxlength="255"
            placeholder="Location" [matAutocomplete]="locationAutocomplete">
          <mat-autocomplete id="locationAutocomplete" #locationAutocomplete>
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let location of locationSelectionList | async" [value]="location">
              {{location}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </span>
    </ng-template>


    <ng-template #descriptionTemplate>
      <span>
        <mat-form-field matTooltip="Description" [matTooltipDisabled]="disabledTooltip(this.description)">
          <mat-label i18n="@@type.Asset.description">Description</mat-label>
          <input matInput formControlName="description" id="description" (ngModelChange)="descriptionChanging($event)"
            [(ngModel)]="item.description" (ngModelChange)="descriptionChanged($event)" #description maxlength="2000"
            placeholder="Description">
        </mat-form-field>
      </span>
    </ng-template>
    
    <ng-template #identityReferenceTemplate>
      <span>
        <mat-form-field matTooltip="Identity Reference" [matTooltipDisabled]="disabledTooltip(this.identityReference)">
          <mat-label i18n="@@type.Asset.identityReference">Identity Reference</mat-label>
          <input matInput formControlName="identityReference" id="identityReference"
            (ngModelChange)="identityReferenceChanging($event)" [(ngModel)]="item.identityReference"
            (ngModelChange)="identityReferenceChanged($event)" #identityReference maxlength="255"
            placeholder="Identity Reference">
        </mat-form-field>
      </span>
    </ng-template>
    
    <ng-template #manufacturerTemplate>
      <span>
        <mat-form-field matTooltip="Manufacturer" [matTooltipDisabled]="disabledTooltip(this.manufacturer)">
          <mat-label i18n="@@type.Asset.manufacturer">Manufacturer</mat-label>
          <input matInput formControlName="manufacturer" id="manufacturer"
            (ngModelChange)="manufacturerChanging($event)" [(ngModel)]="item.manufacturer"
            (ngModelChange)="manufacturerChanged($event)" #manufacturer maxlength="255" placeholder="Manufacturer"
            [matAutocomplete]="manufacturerAutocomplete">
          <mat-autocomplete id="manufacturerAutocomplete" #manufacturerAutocomplete>
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let manufacturer of manufacturerSelectionList | async" [value]="manufacturer">
              {{manufacturer}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </span>
    </ng-template>
    
    <ng-template #modelTemplate>
      <span>
        <mat-form-field matTooltip="Model" [matTooltipDisabled]="disabledTooltip(this.model)">
          <mat-label i18n="@@type.Asset.model">Model</mat-label>
          <input matInput formControlName="model" id="model" (ngModelChange)="modelChanging($event)"
            [(ngModel)]="item.model" (ngModelChange)="modelChanged($event)" #model maxlength="255" placeholder="Model"
            [matAutocomplete]="modelAutocomplete">
          <mat-autocomplete id="modelAutocomplete" #modelAutocomplete>
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let model of modelSelectionList | async" [value]="model">
              {{model}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </span>
    </ng-template>
    
    <ng-template #purchaseDateTemplate>
      <span>
        <mat-form-field matTooltip="Purchase Date" [matTooltipDisabled]="disabledTooltip(this.purchaseDate)">
          <mat-label i18n="@@type.Asset.purchaseDate">Purchase Date</mat-label>
          <input matInput formControlName="purchaseDate" id="purchaseDate"
            (ngModelChange)="purchaseDateChanging($event)" [(ngModel)]="item.purchaseDate"
            (ngModelChange)="purchaseDateChanged($event)" #purchaseDate [matDatepicker]="purchaseDateDatePicker"
            placeholder="Purchase Date">
          <mat-datepicker-toggle matSuffix [for]="purchaseDateDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #purchaseDateDatePicker color="primary"></mat-datepicker>
        </mat-form-field>
      </span>
    </ng-template>

    <ng-template #purchasePriceTemplate>
      <span>
        <mat-form-field matTooltip="Purchase Price" [matTooltipDisabled]="disabledTooltip(this.purchasePrice)">
          <mat-label i18n="@@type.Asset.purchasePrice">Purchase Price</mat-label>
          <input matInput formControlName="purchasePrice" id="purchasePrice"
            (ngModelChange)="purchasePriceChanging($event)" [(ngModel)]="item.purchasePrice"
            (ngModelChange)="purchasePriceChanged($event)" #purchasePrice type="number" placeholder="Purchase Price">
        </mat-form-field>
      </span>
    </ng-template>
    
    <ng-template #commentsTemplate>
      <span>
        <mat-form-field matTooltip="Comments" [matTooltipDisabled]="disabledTooltip(this.comments)"
          class="textarea-full-wide">
          <mat-label i18n="@@type.Asset.comments">Comments</mat-label>
          <textarea matInput formControlName="comments" id="comments" (ngModelChange)="commentsChanging($event)"
            [(ngModel)]="item.comments" (ngModelChange)="commentsChanged($event)" #comments
            placeholder="Comments"></textarea>
        </mat-form-field>
      </span>
    </ng-template>
    
    <ng-template #statusTemplate>
      <span>
        <mat-form-field matTooltip="Select a Status from the list" [matTooltipDisabled]="disabledTooltip(this.status)">
          <mat-label i18n="@@type.Asset.status">Status</mat-label>
          <mat-select formControlName="status" id="status"              
              (ngModelChange)="statusChanging($event)" [(ngModel)]="item.status"              
              (ngModelChange)="statusChanged($event)" #status              
              placeholder="Status">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let status of statusSelectionList" [value]="status.code">
              {{status.meaning}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </span>
    </ng-template>

    <ng-template #tagsTemplate>
      <app-asset-tags-control [item]="item" [readOnly]="readOnly" [createMode]="createMode" [parentAssetComponent]="this"></app-asset-tags-control>
    </ng-template>
    
    <ng-template #updatedCreatedStatsTemplate>
      <app-asset-additional-info-control [item]="item" [readOnly]="readOnly" [createMode]="createMode" [parentAssetComponent]="this"></app-asset-additional-info-control>
    </ng-template>

    <ng-template #aspectsTemplate>
      <app-asset-aspects-control [item]="item" [readOnly]="readOnly" [createMode]="createMode" [parentAssetComponent]="this"></app-asset-aspects-control>
    </ng-template>

  </form>
</div>